import React from 'react';
import type { SocialLink } from './FooterTypes';
import FooterSocial from './FooterSocial';

type FooterBottomProps = {
  socialLinks: SocialLink[];
};

// Very bottom copy and social links

const FooterBottom = ({ socialLinks }: FooterBottomProps): JSX.Element => {
  const year = new Date().getFullYear();

  return (
    <div className="footer-bottom">
      <span className="footer-bottomText">
        ALL RIGHTS RESERVED BY{' '}
        <a
          className="footer-bottomLink"
          href="https://wildcardcorp.com/"
          target="_blank"
          rel="noreferrer"
        >
          Wildcardcorp
        </a>{' '}
        {year}
      </span>

      <FooterSocial links={socialLinks} />
    </div>
  );
};

export default FooterBottom;
